export enum Environment {
  NONPROD = 'nonprod',
  PROD = 'prod',
}

export enum VariantValues {
  WhUkXsell = 'wh-uk-xsell',
  WhUkVegas = 'wh-uk-vegas',
  WhEsXsell = 'wh-es-xsell',
  WhEsCasino = 'wh-es-casino',
}

export type Variant = VariantValues;

export interface AssemblerContext {
  locale: string;
  default_currency: string;
  viewer_country: string;
  viewer_region: string;
  host: string;
  base_path: string;
  market_id: string;
  version: string;
  is_native: string;
}
